import {
  createElementBlock as _createElementBlock,
  createElementVNode as _createElementVNode,
  openBlock as _openBlock
} from 'vue'

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24'
      },
      [
        _createElementVNode('path', {
          fill: 'none',
          d: 'M0 0h24v24H0z'
        }),
        _createElementVNode('path', {
          d: 'M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-5-3a5 5 0 0 1 10 0h-2a3 3 0 0 0-6 0H7zm1-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z'
        })
      ]
    )
  )
}
